import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

export const ContainerModel = styled.div`
  max-width: 100%;
  background: #fff;
  border-radius: 20px;
  margin: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
  }
`;

export const ContentContainerModel = styled.div`
  padding: 16px;
  text-align: center;

  @media (min-width: 1440px) {
    padding: 24px;
  }
`;

export const TitleModel = styled.h1`
  font-size: 24px;
  font-family: Exo2 Light;

  margin-top: 24px;

  @media (min-width: 1440px) {
    font-size: 36px;
  }
`;

export const DescribeMessage = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;

  margin-top: 10px;

  @media (min-width: 428px) {
    margin-top: 20px;
  }

  @media (min-width: 744px) {
    margin-top: 30px;
  }

  @media (min-width: 1440px) {
    font-size: 24px;
  }
`;

export const MessageConfirm = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;

  margin-top: 10px;

  @media (min-width: 428px) {
    margin-top: 20px;
  }

  @media (min-width: 744px) {
    margin-top: 30px;
  }

  @media (min-width: 1440px) {
    font-size: 24px;
  }
`;

export const ContainerValidLink = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;

  margin-top: 10px;

  @media (min-width: 428px) {
    margin-top: 20px;
  }

  @media (min-width: 744px) {
    margin-top: 30px;
  }
`;

export const DescribeTextValid = styled.p`
  font-size: 20px;
  font-family: Exo2 Light;

  @media (min-width: 1440px) {
    font-size: 24px;
  }
`;

export const TextTimer = styled.span`
  font-size: 20px;
  font-family: Exo2 Light;

  @media (min-width: 1440px) {
    font-size: 24px;
  }
`;

export const ContainerIcons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  margin-top: 50px;
`;

export const ContainerStatusEmailDone = styled.div`
  width: 70px;
  height: 70px;
  background: #1ac63f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 428px) {
    width: 85px;
    height: 85px;
  }
`;

export const ContainerStatusEmailUnDone = styled.div`
  width: 70px;
  height: 70px;
  background: #f64747;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 428px) {
    width: 85px;
    height: 85px;
  }
`;

export const ContainerButtons = styled.div`
  max-width: 300px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;

  margin-top: 60px;
  margin-bottom: 24px;

  @media (min-width: 428px) {
    max-width: 348px;
  }

  @media (min-width: 744px) {
    max-width: 300px;
  }

  @media (min-width: 1440px) {
    max-width: 369px;
  }
`;

interface IndicatorProps {
  $filled: boolean;
}

export const ButtonNext = styled.button<IndicatorProps>`
  max-width: 100%;
  padding: 10px 128px;
  background: ${(props) => (props.$filled ? "#1A50C6" : "#6b8eda")};
  border-radius: 20px;
  font-size: 20px;
  color: #fff;
  font-family: Exo2 Medium;

  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }

  @media (min-width: 428px) {
    padding: 10px 152px;
  }

  @media (min-width: 744px) {
    padding: 10px 128px;
  }

  @media (min-width: 1440px) {
    padding: 17px 158px;
    font-size: 24px;
  }
`;

interface IndicatorProps {
  $filled: boolean;
}

// "#6b8eda"
// background: ${(props) => (props.$filled ? "#1A50C6" : "#6b8eda")};
// cursor: ${(props) => (props.disabled ? "pointer" : "not-allowed")};
export const ButtonSendAgain = styled.button`
  max-width: 100%;
  padding: 10px 70px;
  background: #1a50c6;
  border-radius: 20px;
  font-size: 20px;
  color: #fff;
  font-family: Exo2 Medium;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    padding: 10px 95px;
  }

  @media (min-width: 744px) {
    padding: 10px 70px;
  }

  @media (min-width: 1440px) {
    padding: 18px 89px;
    font-size: 24px;
  }
`;
